import { styled } from 'styled-components';
import { Text } from '@wistia/vhs';
import type { JSX } from 'react';
import { useCommentContext, commentingViews } from './CommentContext';

export const Card = styled.div`
  background: white;
  border: 1px solid ${({ theme }) => theme.color.grey300};
  border-radius: 8px;
  padding: 24px;
`;

const CardText = styled(Text)`
  margin-top: 8px;
  max-width: 600px;
`;

const getHeadlineText = (commentingView: string, isAnonymousMedia: boolean): string => {
  if (isAnonymousMedia) {
    return 'No comments yet';
  }
  if (commentingView === commentingViews.audience) {
    return 'No Audience Comments yet';
  }
  return 'No Team Comments yet';
};

const getBodyText = (commentingView: string, isAnonymousMedia: boolean): string => {
  if (commentingView === commentingViews.team) {
    return isAnonymousMedia
      ? 'Leave a comment or share this page to start collaborating on this video.'
      : 'Share for review, tag users, or leave a comment to start collaborating on this video.';
  }
  return isAnonymousMedia
    ? 'Leave a comment to start the conversation.'
    : 'When you have received comments from your audience, you can manage them here.';
};

export const EmptyState = (): JSX.Element => {
  const { commentingView, isAnonymousMedia } = useCommentContext();

  return (
    <Card>
      <CardText variant="headline3">{getHeadlineText(commentingView, isAnonymousMedia)}</CardText>
      <CardText variant="body2">{getBodyText(commentingView, isAnonymousMedia)}</CardText>
    </Card>
  );
};
